/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForAppDynamics extends models.ServiceAccountCredentialsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForAppDynamics");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForAppDynamics.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForAppDynamics>): ServiceAccountCredentialsForAppDynamics {
        let obj = Object.assign(new ServiceAccountCredentialsForAppDynamics(), model);
        ServiceAccountCredentialsForAppDynamics.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForAppDynamics>): ServiceAccountCredentialsForAppDynamics {
        if (!model) return null;
        return ServiceAccountCredentialsForAppDynamics.newInstance(<ServiceAccountCredentialsForAppDynamics> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForAppDynamics) {
        if (!obj) return;

        models.ServiceAccountCredentialsForAppDynamics.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForAppDynamics): boolean {
        if (models.ServiceAccountCredentialsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForAppDynamics.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * API Endpoint. This is a required field.
     */
    appdynamics_url: string;

    /**
     * Client Id. This is a required field.
     */
    client_id: string;

    /**
     * Client Secret. This is a required field.
     */
    client_secret: string;

}
